import { Children, cloneElement, isValidElement } from "react";

// Plain-text help rendered by the app's single shared Bootstrap overlay.
// Cloning keeps table cells, button groups and layout wrappers unchanged.
// The child must forward data-* attributes to its DOM element.
export default function Hint({ label, placement = "top", children }) {
  const child = Children.only(children);
  const content = Children.toArray(child.props.children);
  const icon = content.length === 1 && isValidElement(content[0]) && content[0];
  const needsName = !child.props["aria-label"] && !child.props["aria-labelledby"] &&
    typeof label === "string" && icon &&
    (icon.type === "svg" || Children.count(icon.props.children) === 0);
  return cloneElement(child, {
    ...(needsName ? { "aria-label": label } : {}),
    "data-hint": label || undefined,
    "data-hint-placement": placement,
  });
}
